// @ts-nocheck
import styles from "./index.module.scss";
import InputLabel from "../../../../../base/basicComponents/inputLabel";
import { FileUploadDragger } from "../../../../../base/basicComponents/uploadFile";
import { NormalTextArea } from "../../../../../base/basicComponents/input";
import { useRef, useState } from "react";
import { useSetState } from "ahooks";
import Buttons from "../../../../../base/basicComponents/button";
import NormalModal from "../../../../../base/basicComponents/modal";
import SignOffStepService from "service/procedureFile/signOffStepService";
import { message } from "antd";

const ACTION_TYPE = {
  SUBMIT: "SUBMIT",
  CANCEL: "CANCEL",
};

const AdditionalAttachment = ({
  openLoading,
  hideLoading,
  additionalFiles,
  additionalComment,
  submitIds,
  updateFileNumLoading,
}: any) => {
  // @ts-ignore
  const attachmentRef = useRef();
  // @ts-ignore
  const attachmentInputRef = useRef();
  const [fileList, setFileList] = useState(
    additionalFiles.map((i: any) => ({
      fileName: i.attachFileName,
      fileId: i.fileID,
      isInitFile: true,
    }))
  );
  const latestFileCountRef = useRef(additionalFiles.length);

  const [comment, setComment] = useState(additionalComment);

  const [modal, setModal] = useSetState({
    isModalOpen: false,
    modalChildContent: "",
    actionType: ACTION_TYPE.SUBMIT,
  });

  const handleFileListChange = (list: any) => {
    latestFileCountRef.current = list.length;
    setFileList(
      list.map((i: any) => ({
        fileName: i.name,
        fileId: i.storageFileID,
        isInitFile: false,
      }))
    );
  };

  const handlePreSubmit = async () => {
    await waitingPendingRequests();
    if (latestFileCountRef.current === 0) {
      // @ts-ignore
      attachmentRef.current.checkMandatory();
      return;
    }
    setModal({
      // @ts-ignore
      modalChildContent: (
        <>
          <span>
            Additional Attachment and Comment cannot be edited after submission. Please double-check
            before submitting.
          </span>
          <span style={{ display: "inline-block" }}>Are you sure to submit?</span>
        </>
      ),
      isModalOpen: true,
      actionType: ACTION_TYPE.SUBMIT,
    });
  };

  const handlePreCancel = () => {
    setModal({
      // @ts-ignore
      modalChildContent: <span>Are you sure to quit without saving?</span>,
      isModalOpen: true,
      actionType: ACTION_TYPE.CANCEL,
    });
  };

  const closeModal = () => {
    setModal({ isModalOpen: false });
  };

  const reloadWithMessage = (payload: any) => {
    sessionStorage.setItem("pmp_reload_message", JSON.stringify(payload));
    window.location.reload();
  };

  const submitAdditionalFiles = async () => {
    const payload = {
      signOffStepID: submitIds.signOffStepID,
      procedureStepID: submitIds.procedureStepID,
      procedureTaskID: submitIds.procedureTaskID,
      additionalComment: comment,
      procedureId: submitIds.procedureId,
      additionalFiles: fileList.map((i: any) => ({
        attachFileName: i.fileName,
        fileID: i.fileId,
      })),
    };
    openLoading();

    if (latestFileCountRef.current === 0) {
      hideLoading();
      // @ts-ignore
      attachmentRef.current.checkMandatory();
      return;
    }

    const res = await SignOffStepService.addAdditionalFiles(payload).catch(() => {
      message.error("Fail to add additional Files.");
      hideLoading();
    });

    if (!res.succeeded) {
      message.error("Fail to save additional Files.");
      hideLoading();
      return;
    }
    if (res.data.isExist && !res.data.isSaved) {
      reloadWithMessage({
        type: "warning",
        message:
          "Another user has already uploaded an Additional Attachment file. The page has been refreshed to reflect the latest files.",
        duration: 4,
      });
      return;
    }
    if (!res.data.canUploadAttachment) {
      reloadWithMessage({
        type: "error",
        message: "You don't have permission to upload additional attachments.",
      });
      return;
    }
    if (res.data.isSaved) {
      window.location.reload();
    }
  };

  const cancelWithoutSaving = () => {
    const url = new URL(window.location.href);
    const returnUrl = url.searchParams.get("returnUrl");
    if (returnUrl) {
      // Full-page reload (not history.push): guarantees Router's
      // permission check runs before the target page's own
      // componentDidMount can fire and call its own APIs (PMP-4808).
      window.location.href = returnUrl;
    } else {
      // No returnUrl to go back to (page opened directly rather than from
      // Change History). Reload in place so "quit without saving" still
      // discards the uploaded-but-unsubmitted fileList/comment - a full
      // reload is what resets this component's local state.
      window.location.reload();
    }
  };

  const handleConfirm = async () => {
    closeModal();
    if (modal.actionType === ACTION_TYPE.SUBMIT) {
      await submitAdditionalFiles();
    } else if (modal.actionType === ACTION_TYPE.CANCEL) {
      cancelWithoutSaving();
    }
  };

  const handleCancel = () => {
    closeModal();
  };

  const waitingPendingRequests = () => {
    return new Promise((resolve) => {
      const CHECK_INTERVAL = 100;
      const checkPendingRequests = () => {
        // @ts-ignore
        if (!attachmentRef.current.isDeleting) {
          return setTimeout(resolve, 0);
        }
        setTimeout(checkPendingRequests, CHECK_INTERVAL);
      };
      checkPendingRequests();
    });
  };

  const isDirty = fileList.length > 0;
  const isComplete = fileList.some((i: any) => i.isInitFile);
  return (
    <>
      <div className={styles.additionalContainer}>
        <div>
          <InputLabel text="Additional Attachment" />
          {/* @ts-ignore */}
          <FileUploadDragger
            ref={attachmentRef}
            className={styles.fileDragger}
            fileInputRef={attachmentInputRef}
            isShowBox={true}
            isMultiple={true}
            handleFileListChange={handleFileListChange}
            isShowDeleteBtn={!isComplete}
            openLoading={openLoading}
            hideLoading={hideLoading}
            updateFileNumLoading={updateFileNumLoading}
            fileIds={fileList.filter((i: any) => i.isInitFile).map((i: any) => i.fileId)}
            fileNames={fileList.filter((i: any) => i.isInitFile).map((i: any) => i.fileName)}
            isDownload={true}
            fileNameType="link"
          />
        </div>
        <div>
          <InputLabel text="Comment" />
          <NormalTextArea
            testid="additional-comment-textarea"
            onChange={(e: any) => setComment(e.target.value)}
            value={comment}
            width="44.75"
            className="reasonInput"
            disabled={isComplete}
          />
        </div>
      </div>
      {!isComplete && (
        <div className={styles.additionalButton}>
          <Buttons
            testid="additional-attachment-cancel-btn"
            color="grey"
            disabled={!isDirty}
            size="middle"
            onClick={handlePreCancel}
          >
            Cancel
          </Buttons>
          <Buttons
            testid="additional-attachment-submit-btn"
            color="blue"
            disabled={!isDirty}
            size="middle"
            onClick={handlePreSubmit}
          >
            Submit
          </Buttons>
        </div>
      )}
      <NormalModal
        testid="additional-confirm-modal"
        okText="Confirm"
        cancelText="Cancel"
        childContent={<p className="fs-16">{modal.modalChildContent}</p>}
        isModalOpen={modal.isModalOpen}
        handleOk={handleConfirm}
        handleCancel={handleCancel}
      />
    </>
  );
};

export default AdditionalAttachment;
